import React from 'react';
import { Grid, Column, Breadcrumb, BreadcrumbItem } from '@carbon/react';
import PrivacyDashboard from '../../components/privacy/PrivacyDashboard';
import { AuthGuard } from '../../components/auth/AuthGuard';
import { Link } from 'react-router-dom';

export const PrivacyDashboardPage: React.FC = () => {
  const content = (
    <>
      <Grid fullWidth>
        <Column lg={16} md={8} sm={4}>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/">Home</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/privacy">Privacy</Link>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>Dashboard</BreadcrumbItem>
          </Breadcrumb>
        </Column>
      </Grid>
      <PrivacyDashboard />
    </>
  );

  return <AuthGuard requiredRole="user">{content}</AuthGuard>;
};
